export enum AppRoutes {
  LOGIN = '/login',
  HOME = '/home',
  MEMBROS = '/membros',
  MEMBROS_SINCRONIZAR = '/membros/sincronizar',
  UNIDADES_MINISTERIAIS = '/unidades-ministeriais',
}
